module.exports = __webpack_public_path__ + "static/media/error2.09ec2c39.svg";